export default "__VITE_ASSET__DFcH9Kw2__"